import { render } from "./DivCol.vue?vue&type=template&id=61bd19ec&ts=true"
import script from "./DivCol.vue?vue&type=script&lang=ts"
export * from "./DivCol.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__